import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useMatterRequestTypeSelection } from './useMatterRequestTypeSelection';
import { useMatterRequestSelection } from './useMatterRequestSelection';
import { useLanguage } from '../context/LanguageContext';
import { useNavigationStack } from '../context/NavigationStackContext';
import { useManageMatterRequestContext } from '../context/ManageMatterRequest';

export const useSelectMatterRequestType = () => {
  const { t } = useTranslation();
  const { language: appLanguage } = useLanguage();
  const { goBackWithSelection } = useNavigationStack();
  const { matterRequest, updateManageMatterRequest } = useManageMatterRequestContext();
  const location = useLocation();

  const isCustomerTypeSelection = location.state?.isCustomerTypeSelection;

  const {
    matterRequestTypeList,
    isMatterRequestTypesLoading,
    isFetching,
    setSearchValue,
    paginationRef,
    hasNextPage,
    activeSort,
    setActiveSort,
    refreshMatterRequestTypeList,
  } = useMatterRequestTypeSelection(isCustomerTypeSelection);

  const {
    selectionData,
    currentValue,
    isLoading,
    handleSelectMatterRequestType,
    handleSelectCustomerType,
  } = useMatterRequestSelection(
    matterRequest,
    updateManageMatterRequest,
    goBackWithSelection,
    isCustomerTypeSelection,
    matterRequestTypeList,
    isMatterRequestTypesLoading,
  );

  return {
    t,
    appLanguage,
    isCustomerTypeSelection,
    setSearchValue,
    selectionData,
    currentValue,
    matterRequestTypeList,
    handleSelectCustomerType,
    handleSelectMatterRequestType,
    paginationRef,
    hasNextPage,
    isLoading,
    isFetching,
    activeSort,
    setActiveSort,
    refreshMatterRequestTypeList,
  };
};
